module.exports = __webpack_public_path__ + "img/anchieta.dd42333c.jpeg";